import { connect } from "react-redux";
import { getOrganizationInfoRO } from "../../../../../../store/selectors/appConfig";
import { VisitDetailsEidValidation as VisitDetailsEidValidationComponent } from "./VisitDetailsEidValidation";
import { updateRoProspect } from "../../../../../../store/actions/appConfig";

const mapStateToProps = state => {
  const orgInfoRO = getOrganizationInfoRO(state) || {};
  return {
    existingVisits: orgInfoRO.siteVisitPostEligibility || []
  };
};

const mapDispatchToProps = {
  updateRoProspect
};

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...ownProps,
  ...stateProps,
  ...dispatchProps,
  createFormChangeHandler: handler => handler
});

export const VisitDetailsEidValidation = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(VisitDetailsEidValidationComponent);
